import Helpers from "../helpers";
export default {
    state: {        
        soundElements:null, // soundElements will be loaded in FixedInfo.vue
        isSoundOn:true
    },
    actions:{
        switchSound({ commit, state }, onOrOff = true){
            state.isSoundOn = onOrOff;
            Helpers.localStorage.set("isSoundOn",onOrOff);
        },
        setSoundFromLocalStorage({ commit, state }){
            var isSoundOnLocal = Helpers.localStorage.get("isSoundOn");
            if(isSoundOnLocal === null){
                state.isSoundOn = true;
                Helpers.localStorage.set("isSoundOn",true);
            }else{
                state.isSoundOn = isSoundOnLocal;
            }
        },
        playSound({ commit, state }, soundName){
            if(!state.isSoundOn){
                return;
            }
            if(!state.soundElements[soundName]){
                console.log('Sound not found !');
                return;
            }
            state.soundElements[soundName].currentTime = 0;
            state.soundElements[soundName].play();
        }
    }
}